export function activeSlide1() {
    document.getElementById('slide1')?.classList.add("activeSlide");
    document.getElementById('slide1')?.classList.remove("nextSlide", "lastSlide");
    document.getElementById('slide2')?.classList.remove("activeSlide", "nextSlide", "lastSlide");
    document.getElementById('slide3')?.classList.remove("activeSlide", "nextSlide", "lastSlide");
    document.getElementById('slide4')?.classList.remove("activeSlide", "nextSlide", "lastSlide");
    document.getElementById('slide2')?.classList.add("nextSlide");
    document.getElementById('slide3')?.classList.add("nextSlide");
    document.getElementById('slide4')?.classList.add("lastSlide");
}

export function activeSlide2() {
    document.getElementById('slide2')?.classList.add("activeSlide");
    document.getElementById('slide2')?.classList.remove("nextSlide", "lastSlide");
    document.getElementById('slide1')?.classList.remove("activeSlide", "nextSlide", "lastSlide");
    document.getElementById('slide3')?.classList.remove("activeSlide", "nextSlide", "lastSlide");
    document.getElementById('slide4')?.classList.remove("activeSlide", "nextSlide", "lastSlide");
    document.getElementById('slide1')?.classList.add("lastSlide");
    document.getElementById('slide3')?.classList.add("nextSlide");
    document.getElementById('slide4')?.classList.add("nextSlide");
}

export function activeSlide3() {
    document.getElementById('slide3')?.classList.add("activeSlide");
    document.getElementById('slide3')?.classList.remove("nextSlide", "lastSlide");
    document.getElementById('slide1')?.classList.remove("activeSlide", "nextSlide", "lastSlide");
    document.getElementById('slide2')?.classList.remove("activeSlide", "nextSlide", "lastSlide");
    document.getElementById('slide4')?.classList.remove("activeSlide", "nextSlide", "lastSlide");
    document.getElementById('slide1')?.classList.add("nextSlide");
    document.getElementById('slide2')?.classList.add("lastSlide");
    document.getElementById('slide4')?.classList.add("nextSlide");
}

export function activeSlide4() {
    document.getElementById('slide4')?.classList.add("activeSlide");
    document.getElementById('slide4')?.classList.remove("nextSlide", "lastSlide");
    document.getElementById('slide1')?.classList.remove("activeSlide", "nextSlide", "lastSlide");
    document.getElementById('slide2')?.classList.remove("activeSlide", "nextSlide", "lastSlide");
    document.getElementById('slide3')?.classList.remove("activeSlide", "nextSlide", "lastSlide");
    document.getElementById('slide1')?.classList.add("nextSlide");
    document.getElementById('slide2')?.classList.add("nextSlide");
    document.getElementById('slide3')?.classList.add("lastSlide");
}